import { Component, inject, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BusinessService } from '../../shared/services/business.service';
import { ModalService } from '../../shared/utils/services/modal.service';
import { EditBusinessProfileComponent } from '../../shared/ui/edit-business-profile/edit-business-profile.component';
import { ManagePaymentAccountsComponent } from '../../shared/ui/manage-payment-accounts/manage-payment-accounts.component';

@Component({
  selector: 'qwiko-settings',
  imports: [
    CommonModule,
    ManagePaymentAccountsComponent,
    TranslocoModule,
    RouterModule,
    EditBusinessProfileComponent,
  ],
  templateUrl: './settings.page.html',
  styleUrl: './settings.page.scss',
})
export class SettingsPage {
  modalService = inject(ModalService);
  businessService = inject(BusinessService);
  loading = signal<boolean>(false);
  isManagePaymentAccount = signal<boolean>(false);

  async loadBusinessData() {
    this.loading.set(true);
    await this.businessService.getUserBusinesses();
    await this.businessService.getBusinessPaymentAccounts();
    this.loading.set(false);
  }

  managePaymentAccounts() {
    this.isManagePaymentAccount.set(true);
    this.modalService.open('manage-payment-accounts');
  }
}
